import {Component,Input, ViewChild} from '@angular/core';
import { DialogComponent, DialogService } from "ng2-bootstrap-modal";
export interface ConfirmModel {
  title:string;
  message:string;
}
@Component({  
    selector: 'confirm',
    template: `<div class="vertical-alignment-helper"><div class="modal-dialog">
                <div class="modal-content">
         
                   <div class="poupupTitle">
                     <h5 class="modal-title">{{title || 'Confirm'}}</h5>
                   </div>
               
                   <div class="modal-body">
                   <div class="firstPopup">
                     <p>{{message || 'Are you sure?'}}</p>
                     </div>
                   </div>
                   <div class="modal-footer">
                     <button type="button" class="btn btn-default btn-orange" (click)="confirm()">OK</button>
                   </div>
                 </div>
              </div></div>`
})
export class PopupSignupComponent extends DialogComponent<ConfirmModel, boolean> implements ConfirmModel {
  title: string;
  message: string;
  constructor(dialogService: DialogService) {
    super(dialogService);
  }
  confirm() {
    this.result = true;
    this.close();
  }
  
}



// WEBPACK FOOTER //
// ./src/app/users/popup/popup-signup.component.ts